export const OTHERS_CATEGORY = 'Others' as const;

// How many distinct categories the UI renders (legend rows, per-category
// pickers, match-expression branches); everything beyond falls into "Others".
// Matches the worker's per-column stored-values cap (MAX_STORED_VALUES in
// app/services/file_processor_utils.py) and its WEBAPP_RENDER_CAP mirror in
// app/services/layer_restat.py -- change them together.
export const MAX_RENDERED_CATEGORIES = 500;

export const MAX_PREVIEW_ICONS = 5;
export const DEFAULT_ICON_CLASSNAME_COLOR = 'text-gray-600';

export const ICON_SIZES = {
  DEFAULT: 16,
  LEGEND: 12,
} as const;
